import { render, staticRenderFns } from "./CameraSummaryGeneral.vue?vue&type=template&id=27b616dc&scoped=true"
import script from "./CameraSummaryGeneral.vue?vue&type=script&lang=ts"
export * from "./CameraSummaryGeneral.vue?vue&type=script&lang=ts"
import style0 from "./CameraSummaryGeneral.vue?vue&type=style&index=0&id=27b616dc&prod&lang=css"
import style1 from "./CameraSummaryGeneral.vue?vue&type=style&index=1&id=27b616dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b616dc",
  null
  
)

export default component.exports